/** Completion changes readiness, never which image the user is editing. */
export function creativeEditFocus(
 selectedId: string | null,
 intent: Record<string, boolean>,
 prepares: Record<string, {phase: string}>,
 anotherToolActive = false,
): string | null {
 return selectedId && !anotherToolActive && intent[selectedId] && prepares[selectedId]
  ? selectedId : null;
}
